// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {Checkbox, FormHelperText, Input, InputLabel, Select} from "@mui/material";

// App Imports
import {

    getContractCS, graftSection
} from "./ContractSectionClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getContractsByType, getSomeContracts} from "../Contract/ContractClient";
import Stack from "@mui/material/Stack";
import {changeContractSection} from "./contractSectionSlice";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {changeContract} from "../Contract/contractSlice";


// Main Function
export default function ContractSectionGraftingForm({fetchContractSections}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(false);
    const [showCategoryMenu, setShowCategoryMenu] = React.useState(false);
    const [showContractMenu, setShowContractMenu] = React.useState(false);
    const [showParentMenu, setShowParentMenu] = React.useState(false);
    const [showPreviousMenu, setShowPreviousMenu] = React.useState(false);

    const [allDpv, setAllDpv] = useState([]);
    const [contractTypeDropdown, setContractTypeDropdown] = useState([]);
    const [participationContractDropdown, setParticipationContractDropdown] = useState([]);
    const [royaltyContractDropdown, setRoyaltyContractDropdown] = useState([]);
    const [residualContractDropdown, setResidualContractDropdown] = useState([]);
    const [configurationDropdown, setConfigurationDropdown] = useState([]);

    const [contractCategoryDropdown, setContractCategoryDropdown] = useState([]);
    const [contractCategory, setContractCategory] = useState([]);

    const selectedCdpDp = useSelector((state) => state.contractSectionSlc.value.dataPointId);
    // const selectorContractId = useSelector((state) => state.contractSectionSlc.value.contractSectionId);
    const selectorContractName = useSelector((state) => state.contractSectionSlc.value.contractName);
    const selectorSectionId = useSelector((state) => state.contractSectionSlc.value.contractSectionId);
    const selectorSectionName = useSelector((state) => state.contractSectionSlc.value.sectionName);

    const mousedContractSectionId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedId);

    const [contractDropdown, setContractDropdown] = useState([]);
    const [selectedContract, setSelectedContract] = useState(0);
    let contractFilter;

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);
    const selectorCsGraftingDrawerState = useSelector((state) => state.contractSectionSlc.value.csGraftingDrawerState);
    const selectorContractAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);


    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    // const selectorParentId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedParentSectionId);

    // const selectorPreviousId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedPreviousSectionId);
    const selectorContractId = useSelector((state) => state.contractSlc.value.id);
    const [parentDropdown, setParentDropdown] = useState([]);

    const [selectedParent, setSelectedParent] = useState(useSelector((state) => state.contractDrilldownSlcCS.value.mousedParentSectionId));
    // const comboParent = selectorParentId !== undefined > 0 ? selectorParentId : selectedParent;

    const [previousDropdown, setPreviousDropdown] = useState([]);
    // const [selectedPrevious, setSelectedPrevious] = useState(useSelector((state) => state.contractDrilldownSlcCS.value.mousedPreviousSectionId));
    const [selectedPrevious, setSelectedPrevious] = useState(null);
    const [selectedOrigin, setSelectedOrigin] = useState(null);

    const selectorCsDrawerMode = useSelector((state) => state.contractSectionSlc.value.csDrawerMode);




    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm(
        // {
        //     defaultValues: {
        //         include_filters: true
        //     }
        // }
    );

    // ****************** END REGISTER ****************************

    const fetchDataPointValuesForDropdowns = React.useCallback (() => {
        console.log("fetchDataPointValuesForDropdowns triggered");
        getAllDataPointValues()

            .then(data => {
                console.log("This is the data point values for the dropdowns");
                setAllDpv(data);
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setContractTypeDropdown(data.filter(data => data.dataPointId === 89 || (data.dataPointId === 90 && data.id === 802) ));
                setParticipationContractDropdown(data.filter(data => data.dataPointId === 2127));
                setRoyaltyContractDropdown(data.filter(data => data.dataPointId === 2128));
                setResidualContractDropdown(data.filter(data => data.dataPointId === 2126));
                setConfigurationDropdown(data.filter(data => data.dataPointId === 2197));
                setContractCategoryDropdown(data.filter(data => data.dataPointId === 2127));
            })
    },[]);

    useEffect(() => {
        fetchDataPointValuesForDropdowns()
    },[fetchDataPointValuesForDropdowns])





    const fetchDestinationContracts = () =>
        // getSomeContracts(selectorContractAPI)
        getContractsByType(contractCategory)
            .then(data => {
                console.log(data);

                setContractDropdown(data);

            })
    useEffect(() => {
        console.log("This is triggering the fetch for the contract dropdown...");
        fetchDestinationContracts();
    }, [contractCategory]);


    const handleContractTypeChange = (contractTypeEvent) => {
        console.log("This is the selected Contract Category after change");
        setContractCategoryDropdown(
            contractTypeEvent.target.value === 45 ? residualContractDropdown :
                contractTypeEvent.target.value === 46 ? participationContractDropdown :
                    contractTypeEvent.target.value === 47 ? royaltyContractDropdown :
                        contractTypeEvent.target.value === 802 ? configurationDropdown :
                            []
        );

        setContractCategory(null);
        setSelectedParent(null);
        setSelectedPrevious(null);
        console.log("This is for the selected Contract Type");
        console.log(contractTypeEvent.target.value);
        setSelectedContract(null);
        contractFilter = null;
        setShowCategoryMenu (true);
        setShowContractMenu (false);
        setShowParentMenu (false);
        setShowPreviousMenu (false);
        // dispatchData(changeContract({id: contractCategoryEvent.target.value, name: contractCategoryEvent.target.value}))
        // fetchDestinationContracts()
    };


    const handleContractCategoryChange = (contractCategoryEvent) => {
        console.log("This is the selected Contract Category after change");
        contractFilter = contractCategoryEvent.target.value;
        setContractCategory(
            contractCategoryEvent.target.value === 3214 ? 'PartsAbstracts' :
                contractCategoryEvent.target.value === 3771 ? 'Branches' :
                    contractCategoryEvent.target.value === 1234 ? 'PartsDocuments' :
                        contractCategoryEvent.target.value === 1232 ? 'PartsStandards' :
                            contractCategoryEvent.target.value === 3235 ? 'PartsPackages' :
                                contractCategoryEvent.target.value === 1233 ? 'PartsRiders' :
            contractCategoryEvent.target.value === 1224 ? 'CBA' :
                contractCategoryEvent.target.value === 1225 ? 'Sideletter' :
                    contractCategoryEvent.target.value === 2119 ? 'SideletterTemplate' :
                        contractCategoryEvent.target.value === 6565 ? 'DeterminationLetter' :
            contractCategoryEvent.target.value === 2937 ? 'RoyalStandards' :
                contractCategoryEvent.target.value === 3336 ? 'RoyalAbstracts' :
                    contractCategoryEvent.target.value === 2939 ? 'RoyalBands' :
                        contractCategoryEvent.target.value === 2940 ? 'RoyalLicenses' :
                            contractCategoryEvent.target.value === 1270 ? 'PartsPre' :
                                contractCategoryEvent.target.value === 1271 ? 'PartsPost' :
                                    contractCategoryEvent.target.value === 1276 ? 'PartsSystem' :
                                    contractCategoryEvent.target.value
                                      );
        setSelectedParent(null);
        setSelectedPrevious(null);
        console.log("This is for the selected Contract Category");
        console.log(contractCategoryEvent.target.value);
        setSelectedContract(null);
        contractFilter = null;
        setShowContractMenu (true);
        setShowParentMenu (false);
        setShowPreviousMenu (false);
        // dispatchData(changeContract({id: contractCategoryEvent.target.value, name: contractCategoryEvent.target.value}))
        // fetchDestinationContracts()
    };

    const handleContractChange = (contractEvent) => {
        contractFilter = contractEvent.target.value;
        setSelectedContract(contractEvent.target.value);
        setSelectedParent(null);
        setSelectedPrevious(null);
        setShowParentMenu (true);
        setShowPreviousMenu (false);
        console.log("This is for the selected Contract Section");
        console.log(contractEvent.target.value)
        // dispatchData(changeContract({id: contractEvent.target.value, name: contractEvent.target.value}))
        // fetchContractSectionsForParent()
    };


    let parentFilter = null;

    const fetchContractSectionsForParent = () =>
        getContractCS(selectedContract)

            .then(data => {
                console.log(data);
                console.log("showParentMenu = ", showParentMenu);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );

                setParentDropdown(data);
                setShowParentMenu (true);
            })
    useEffect(() => {
        console.log("This is triggering the fetch for the parent section dropdown...");
        fetchContractSectionsForParent();
    }, [selectedContract]);


    // const handleParentChange = (parentEvent) => {
    //     parentFilter = parentEvent.target.value;
    //     setSelectedParent(parentEvent.target.value);
    //     console.log("This is the selected Parent Section after change");
    //     console.log(parentEvent.target.value);
    //     console.log(selectedParent);

    //     const handleParentChange = (parentEvent) => {
    //         const newParentId = parentEvent.target.value;
    //
    //         setSelectedParent(newParentId);
    //         setSelectedPrevious(null);
    //         setPreviousDropdown([]);
    //         setShowPreviousMenu(true);
    //     };
    //
    // useEffect(() => {
    //     if (selectedContract == null) return;
    //
    //     fetchContractSectionsForPrevious(selectedParent);
    //
    // }, [selectedParent, selectedContract]);



    //     fetchContractSectionsForPrevious()
    //         .then(() => {
    //             console.log("selectedParent")
    //             // dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
    //         })
    //     setShowPreviousMenu (true);
    // };
    //
    //


    // const fetchContractSectionsForPrevious = (parentId) =>
    //     getContractCS(selectedContract)
    //         .then(data => {
    //             console.log("Selected parent:", parentId);
    //             console.log("Available sections:", data);
    //
    //             const filteredData =
    //                 parentId !== null &&
    //                 parentId !== undefined &&
    //                 parentId !== ""
    //                     ? data.filter(item =>
    //                         Number(item.parentSectionId) === Number(parentId)
    //                     )
    //                     : data.filter(item => item.recordLevel === 1);
    //
    //             console.log("Filtered previous sections:", filteredData);
    //
    //             setPreviousDropdown(filteredData);
    //         });


    const handleParentChange = (parentEvent) => {
        const newParentId = parentEvent.target.value;

        console.log("New Parent ID:", newParentId);

        setSelectedParent(newParentId);
        setSelectedPrevious(null);
        setPreviousDropdown([]);
        setShowPreviousMenu(true);
    };


    const fetchContractSectionsForPrevious = (parentId) => {
        console.log("Fetching previous sections for parent:", parentId);

        return getContractCS(selectedContract)
            .then(data => {

                const filteredData = data.filter(item =>
                    Number(item.parentSectionId) === Number(parentId)
                );

                console.log("Filtered previous sections:", filteredData);

                setPreviousDropdown(filteredData);
            });
    };


    useEffect(() => {
        if (
            selectedContract == null ||
            selectedParent == null ||
            selectedParent === ""
        ) {
            setPreviousDropdown([]);
            return;
        }

        fetchContractSectionsForPrevious(selectedParent);

    }, [selectedParent, selectedContract]);

    // const fetchContractSectionsForPrevious = () =>
    //
    //     getContractCS(selectedContract)
    //
    //         .then(data => {
    //             console.log(data);
    //
    //             if(parentFilter !== null && parentFilter !== ""){
    //                 setPreviousDropdown(data.filter(data => data.parentSectionId ===  parentFilter));
    //                 console.log("We're filtering for records with the same parent");
    //                 console.log("selectedParent = ", selectedParent);
    //                 // console.log("selectorParentId = ", selectorParentId);
    //                 console.log("selectedPrevious = ", selectedPrevious);}
    //             else
    //             {setPreviousDropdown(data.filter(data => data.recordLevel ===  1));}
    //
    //         })
    //         .then(() => console.log("selectedParent"))
    //         .then(() => console.log({selectedParent}))
    //         // .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
    //         // .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})

    // useEffect(() => {
    //     console.log("This is for the dropdown2...");
    //     fetchContractSectionsForPrevious()
    //         .then(() => {
    //             console.log("selectedParent")
    //             // dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
    //         })
    // }, []);


    const handlePreviousChange = (previousEvent) => {
        setSelectedPrevious(previousEvent.target.value);
        console.log("This is the selected Previous Section after change");
        console.log(previousEvent.target.value);
    };




    // ****************** BEGIN CRUD ****************************

    // function onSubmit(data) {
    //     console.log("here's my contractSection data before I submit it ")
    //     console.log({data})
    // }

    function onSubmit(data) {
        setSubmitting(true)
        // let source_section_id = parseInt(data.source_section_id)
        // let parent_section_id = parseInt(data.destination_section_id)
        // let previous_section_id = parseInt(data.destination_section_id)

        console.log("here's my contractSection data before I submit it for grafting")
        console.log({data})

        graftSection(mousedContractSectionId, selectedParent, selectedPrevious)
            .then(() => {
                console.log("Grafting data Submitted After");
                console.log(mousedContractSectionId,selectedParent,
                    selectedPrevious)
            })
            .catch(err => {
                console.log(err)
            })                .then(() => {
        })
            .then(() =>{
                setSubmitting(false);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Branch grafted"}));
                dispatchData(changeContractSection({csCloningDrawerState: false}))})
            .finally(() => {
                dispatchData(changeContractSection({
                    csGraftingDrawerState: false, csGridRefresh: true}));
            })


    };

    // ****************** END CRUD ****************************





    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeContractSectionDrawer() {
        dispatchData(changeContractSection({
            csGraftingDrawerState: false}));



    };

    // ****************** END MISC ****************************

    // *********************** BEGIN DROPDOWNS **************************

    const [sectionDropdown, setSectionDropdown] = useState([]);




// *********************** END DROPDOWNS **************************



    // ****************** BEGIN FORM ****************************

    function contractSectionForm(){

        // const {register, handleSubmit} = useForm(
        //     {
        //         defaultValues: {
        //             include_filters: true
        //         }
        //     }
        // );

        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >
                    <h1 style={{cursor: 'pointer'}}
                        onClick={() => closeContractSectionDrawer()}
                    >Branch Grafting Form</h1>

                    <h4>Grafting Branch:</h4>
                    <h4>{useSelector((state) => state.contractDrilldownSlcCS.value.mousedName)}</h4>
                    <br/>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="contractList.id">Contract Type</InputLabel>
                        <Select
                            onChange={handleContractTypeChange}
                        >
                            {contractTypeDropdown.map((contractTypeItem) =>
                                <MenuItem value={contractTypeItem.id}>{contractTypeItem.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">choose the contract Type</FormHelperText>
                    </FormControl>
                    <br/>
                    {showCategoryMenu && <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="contractList.id">Contract Category</InputLabel>
                        <Select
                            onChange={handleContractCategoryChange}
                        >
                            {contractCategoryDropdown.map((contractCategoryItem) =>
                                <MenuItem value={contractCategoryItem.id}>{contractCategoryItem.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">choose the contract category</FormHelperText>
                    </FormControl>}


                    <br/>
                    {showContractMenu &&
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="destinationContract.id">Destination Contract</InputLabel>
                        <Select
                            onChange={handleContractChange}
                        >
                            {contractDropdown.map((contractItem) =>
                                <MenuItem value={contractItem.id}>{contractItem.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">choose the destination contract</FormHelperText>
                    </FormControl>}
                    <br/>
                    {/*<br/>*/}


                    {/*<br/>*/}
                    {/*<br/>*/}
                    <br/>
                    {showParentMenu &&
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                 // style={{ visibility: selectorCsDrawerMode === "Edit" ? "hidden" : "visible"}}>
                            >
                        <InputLabel htmlFor="parentSectionId">Parent Section</InputLabel>
                        <Select
                            {...register('parentSectionId', { required: false })}
                            labelId="demo-simple-select-filled-parent"
                            id="parentSectionId"

                            value= {selectedParent}
                            // value= {selectorParentId === undefined || selectorParentId === null ? selectedParent : selectorParentId}
                            label="Parent Section"
                            onChange={handleParentChange}
                        >
                            {parentDropdown.map((parentItem) =>
                                <MenuItem
                                    value={parentItem.id}
                                    sx={{
                                        fontWeight: parentItem.recordLevel === 1 ? 'bold' : 'normal',
                                        pl: parentItem.recordLevel * 2 }}
                                >{parentItem.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">select the parent section this will go under</FormHelperText>
                    </FormControl>}
                    {/*<br/>*/}
                    <br/>
                    {showPreviousMenu &&
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                     // style={{ visibility: selectorCsDrawerMode === "Edit" ? "hidden" : "visible"}}
                        >
                            <InputLabel  htmlFor="previousSectionId">Previous Section</InputLabel>
                            <Select
                                {...register('previousSectionId', { required: false })}
                                labelId="demo-simple-select-filled-label2"
                                id="previousSectionId"
                                label="Previous Section"
                                // value= {selectorPreviousId === undefined || selectorPreviousId === null  ? selectedPrevious : selectorPreviousId}
                                value=        {selectedPrevious}
                                onChange={handlePreviousChange}
                                // defaultValue=        {selectedPrevious}
                            >
                                {previousDropdown.map((previousItem) =>
                                    <MenuItem value={previousItem.id}>{previousItem.name} - {previousItem.ordinalNumber}</MenuItem>
                                )}
                            </Select>
                            <FormHelperText id="origin_helper">select the section this will go after within the parent</FormHelperText>
                        </FormControl>}
                    {showPreviousMenu &&<br/>}

                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeContractSectionDrawer()}>Cancel</Button>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorCsGraftingDrawerState}
                initialState={{open: false}}
                onClose={closeContractSectionDrawer}
            >
                {contractSectionForm()}
            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
